export default class DirectDebit {
    constructor(account, routing, region, institution, branch, isValid) {
        this.account = account || document.getElementById("accountNum");
        this.routing = routing || document.getElementById("routingNum");
        this.region = region; // || take from route
        this.institution = institution;
        this.branch = branch;
        this.isValid = isValid || false;

        this.account.addEventListener("input", (e) => { this.validateAccount(e); }, false);
        this.account.addEventListener("focus", (e) => { this.removeValidation(e); }, false);
        this.routing.addEventListener("input", (e) => { this.validateRouting(e); }, false);
        this.routing.addEventListener("focus", (e) => { this.removeValidation(e); }, false);
    }

    validateAccount(e) {
        var account = e.target.value = this.sanitizeInput(e.target.value);

        switch (this.region.toUpperCase()) {
            case "US":
                this.isValid = /^\d{17}/.test(account);
                break;
            case "CA":
                this.isValid = /^\d{12}/.test(account);
                break;
            case "AU":
                this.isValid = /^\d{2,9}/.test(account);
                break;
            case "NZ":
                this.isValid = /^\d{9,10}/.test(account);
                break;
        }
    }

    validateRouting(e) {
        var routing = e.target.value = this.sanitizeInput(e.target.value);

        switch (this.region.toUpperCase()) {
            case "US":
                this.isValid = /^((0[0-9])|(1[0-2])|(2[1-9])|(3[0-2])|(6[1-9])|(7[0-2])|80)([0-9]{7})$/.test(routing); // Regex for valid US this routing numbers.
                break;
            case "CA":
                this.isValid = this.createBranchInstituteNumbers(routing);
                break;
            case "AU":
                this.isValid = this.createBSBNumber(routing);
                break;
            case "NZ":
                this.isValid = /^\d{6}/.test(routing);
                break;
        }                                         

        if (document.activeElement === this.routing && this.routing.selectionStart.toString() === this.routing.getAttribute("maxlength"))
            this.account.focus(); // Handle moving cursor to next input.
    }

    // Specific inputs for Canada bank drafts. Format: XXXXX-YYY (X = branch, Y = institution).
    createBranchInstituteNumbers(value) {
        if (!value || value.length !== 8) return false;
        var transit = value.replace(/(\d{5})/, "$1-").replace(/(\d{5}) (\d{3})/, "$1-$2");
        this.branch = transit.substring(0, 5);
        this.institution = transit.substring(6);
        this.routing.value = transit;
        return this.branch.length === 5 && this.institution.length === 3;
    }

    // Specific input for Australia bank drafts. Format: XXX-XXX (X = BSB).
    createBSBNumber(value) {
        if (!value || value.length !== 6) return false;
        var BSB = value.replace(/(\d{3})/, "$1-").replace(/(\d{3}) (\d{3})/, "$1-$2");
        this.routing.value = BSB;
        return value.length === 6;
    }

    sanitizeInput(e) {
        return e.replace(/\D/g, "");
    }

    removeValidation(e) {
        e.target.classList.remove("input-validation-error");
    }
}